import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@mydocma/auth';
import { MainComponent } from './main/main.component';
import { ShareLinkGuard } from 'projects/mydocma/pr/src/lib/guards/share-link-guard';
import { DocumentViewGuard } from 'projects/mydocma/pr/src/lib/guards/document-view.guard';
import { ShareLinkMainComponent } from './share-link-main/share-link-main.component';
import { DocumentPreviewMainComponent } from './document-preview-main/document-preview-main.component';

const routes: Routes = [
  {
    path: 'share/:customerId/:shareId',
    component: ShareLinkMainComponent,
    canActivate: [ShareLinkGuard],
    loadChildren: () =>
      import('../../projects/mydocma/pr/src/lib/share-doc-link.module').then(
        (m) => m.ShareDocLinkModule,
      ),
  },
  {
    path: 'projects/:projectId/document/:documentId',
    component: DocumentPreviewMainComponent,
    canActivate: [DocumentViewGuard],
    loadChildren: () =>
      import('../../projects/mydocma/pr/src/lib/document-view.module').then(
        (m) => m.DocumentViewModule,
      ),
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('../../projects/mydocma/pr/src/lib/pr-routing.module').then(
            (m) => m.PrRoutingModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
